











import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
// import { State, Action } from 'vuex-class'

import ProductResourceHelperComponents1MainPage from './service-for-product-resource-helper-components/product-resource-helper-components-1-main-page.vue'
import App4PageNotFound from '../../../html-components-type-1-basic/basic-type-1-app/app-4-page-not-found.vue'

// const namespace = 'digitalCurrency'

@Component({
  components: {
    ProductResourceHelperComponents1MainPage,
    App4PageNotFound
  }
})
class ProductResource1 extends Vue {

  // @Action('getDigitalCurrencyTransactionById', { namespace }) getDigitalCurrencyTransactionById?: any

  productResourceId: string = ''

  show404Message: boolean = false

  @Watch('$route.params.productResourceId') async updateRouteValue () {
    await this.initializeProductResource()
  }

  async mounted () {
    await this.initializeProductResource()
  }

  async initializeProductResource () {
    this.show404Message = false
    const productResourceId = this.$router.currentRoute.params.productResourceId

    console.log('productResourceId: ', productResourceId)
    // const digitalCurrencyTransaction = null // await this.getDigitalCurrencyTransactionById(transactionId)

    // if (!digitalCurrencyTransaction || !digitalCurrencyTransaction.transactionId) {
    //   this.show404Message = true
    //   return
    // }

    // this.transactionId = digitalCurrencyTransaction.transactionId
  }
}

export default ProductResource1


